import { ValidationError } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/validators/ValidatorError';
import { ContentActionViewModelValidator } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/validators/ContentActionViewModelValidator';
import { Validator } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/validators/Validator';
import { ActionViewModelValidator } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/validators/ActionViewModelValidator';
import { OutputViewModelValidator } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/validators/OutputViewModelValidator';
import { validateActionViewModelToActionTools } from '../../aiAgent/utils/AgentUtils';
export class CommonStateViewModelValidator extends Validator {
    constructor() {
        super();
        this.contentActionViewModelValidator = new ContentActionViewModelValidator();
        this.actionViewModelValidator = new ActionViewModelValidator();
        this.outputViewModelValidator = new OutputViewModelValidator();
    }
    validate(model) {
        if (!model.$defaultOutput) {
            throw new ValidationError('The state default output is required');
        }
        const validationErrors = [];
        // Validate contents
        model.$invalidContentActions = false;
        if (model.$contentActions) {
            model.$contentActions.forEach((c) => {
                if (!this.contentActionViewModelValidator.isValid(c)) {
                    validationErrors.push(c.$validationError);
                    model.$invalidContentActions = true;
                }
            });
        }
        // Validate outputs
        model.$invalidOutputs = false;
        if (model.$conditionOutputs) {
            model.$conditionOutputs.forEach((o) => {
                if (!this.outputViewModelValidator.isValid(o)) {
                    validationErrors.push(o.$validationError);
                    model.$invalidOutputs = true;
                }
            });
        }
        if (!this.outputViewModelValidator.isValid(model.$defaultOutput)) {
            validationErrors.push(model.$defaultOutput.$validationError);
        }
        // Validate custom actions
        model.$invalidCustomActions = false;
        if (model.$enteringCustomActions) {
            model.$enteringCustomActions.forEach((a) => {
                if (!this.actionViewModelValidator.isValid(a)) {
                    validationErrors.push(a.$validationError);
                    model.$invalidCustomActions = true;
                }
            });
        }
        if (model.$leavingCustomActions) {
            model.$leavingCustomActions.forEach((a) => {
                if (!this.actionViewModelValidator.isValid(a)) {
                    validationErrors.push(a.$validationError);
                    model.$invalidCustomActions = true;
                }
            });
        }
        if (model.$localCustomActions) {
            model.$localCustomActions.forEach((a) => {
                const { errors } = validateActionViewModelToActionTools(a, model);
                if (!this.actionViewModelValidator.isValid(a) || errors?.length > 0) {
                    a.$invalid = true;
                    validationErrors.push(a.$validationError);
                    model.$invalidCustomActions = true;
                }
                else {
                    a.$invalid = false;
                }
            });
        }
        if (validationErrors.length > 0) {
            throw new ValidationError(`One or more validation errors occurred: ${validationErrors
                .map((e) => e.message)
                .join()}`);
        }
    }
}
